import React, { PureComponent } from 'react';
import { string, node, bool, number } from 'prop-types';
import classnames from 'classnames';
import Transition from 'react-transition-group/Transition';
import './CollapseTransition.scss';

const duration = 300;

export default class CollapseTransition extends PureComponent {
    transitionStyles = {
        entering: { maxHeight: this.props.maxHeight },
        entered: { maxHeight: this.props.maxHeight },
        exiting: { maxHeight: 0 },
        exited: { maxHeight: 0 },
    };

    defaultStyle = {
        transition: `max-height ${duration}ms ease`,
        maxHeight: 0,
    };

    static propTypes = {
        in: bool,
        className: string,
        maxHeight: number,
        children: node.isRequired,
        childrenClassName: string,
    };

    static defaultProps = {
        in: false,
        className: null,
        maxHeight: 330,
        childrenClassName: null,
    };

    render() {
        const {
            className,
            in: inProp,
            children,
            childrenClassName,
        } = this.props;
        const rootClassnames = classnames(
            'collapse-transition-root',
            className,
        );

        return (
            <Transition in={inProp} timeout={duration}>
                {state => (
                    <div
                        className={rootClassnames}
                        style={{
                            ...this.defaultStyle,
                            ...this.transitionStyles[state],
                        }}
                    >
                        <div className={childrenClassName}>{children}</div>
                    </div>
                )}
            </Transition>
        );
    }
}
